<template>
  <div class="w-full px-4 xl:px-0">
    <div
      v-if="filteredTips.length"
      class="hidden lg:grid tips-by-status items-center text-bs-dark-bg-over dark:text-white mb-2 px-3 text-left gap-4"
    >
      <div />
      <h3>Home / Away</h3>
      <h3>Competition</h3>
      <h3>Change</h3>
      <h3>Performance</h3>
      <h3>Handicap</h3>
      <h3>Stake</h3>
      <h3>Odd</h3>
    </div>
    <tip-details-row
      class="hidden lg:grid"
      v-for="tip in filteredTips"
      :key="tip.id"
      v-bind="tip"
    />
    <tip-item-expanded
      class="flex lg:hidden"
      v-for="tip in filteredTips"
      :key="tip.id"
      v-bind="tip"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TipItemExpanded from "../atoms/TipItemExpanded.vue";
import TipDetailsRow from "../molecules/TipDetailsRow.vue";
export default {
  components: { TipDetailsRow, TipItemExpanded },
  props: {
    which: {
      type: String,
    },
  },
  computed: {
    ...mapGetters(["tips"]),
    filteredTips: function () {
      return this.tips
        .filter((t) =>
          this.which === "ALL" ? t.status !== "PENDING" : t.status === this.which
        )
        .filter((t) => t.virtualEquityAfterTip !== null)
        .sort((a, b) => (a.createdDate > b.createdDate ? -1 : 1));
    },
  },
};
</script>

<style lang="scss" scoped>
.tips-by-status {
  grid-template-columns: 5rem 2fr 1fr 0.4fr 1fr 5rem 8rem 5rem;
  grid-template-rows: 1fr;
}
</style>
